
                export default function (Component) {
                    Component.__source = "library/components/VabSearch/index.vue"
                }
            